import axios from "axios";
import home from "../../home/home";
import {
  calculateTimeDifferenceTwoDates,
  geDataFormat,
  logOut,
} from "../../../common/utils";
import jwt_decode from "jwt-decode";
import mookAree from "../../../common/mookup/mookAree.json";
export default class DashboardAreeService {
  // getDataTableArea(onSuccess){
  //   onSuccess(mookAree)
  // }



  getAllMarker(dataInizio, dataFine ,onSuccess) {
    var objUser = JSON.parse(sessionStorage.getItem("user"));
    var decoded = jwt_decode(objUser.token);
    let host = process.env.REACT_APP_API_URL;
    const configHeaders = {
      headers: {
        Authorization: "Bearer " + objUser.token,
        CF: decoded.CFA,
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Headers":
          "Origin, X-Requested-With, Content-Type, Accept",
        "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
      },
    };

    // dataInizio === "" ? dataInizio = new Date().setDate(new Date().getDate() - 30) :dataInizio =  +new Date(dataInizio);
    // dataFine === "" ?dataFine = + new Date() :  dataFine = +new Date(dataFine);

    // console.log(new Date(dataFine))
    // console.log(new Date(dataInizio))

    const dataOreInizio =  new Date().setDate(new Date().getDate() - 30);
    const dataOraCorrettaInizio  = new Date(dataOreInizio).setHours(0, 0, 0);

    dataInizio === ""
      ? (dataInizio = dataOraCorrettaInizio)
      : (dataInizio = +new Date(dataInizio).setHours(0, 0, 0));
    dataFine === ""
      ? (dataFine = +new Date().setHours(23,59, 59))
      : (dataFine = +new Date(dataFine).setHours(23,59, 59));

    axios.get(host + "/api/v1/mappatura/find/ALL?dataFrom=" + dataInizio + "&dataTo="+ dataFine, configHeaders).then(
      function (result) {
        if(result.status === 401){
          logOut();
        }
        onSuccess(result);
      },
      function (error) {
       if(error.response.status === 401){
          logOut();
        }
        console.log("Errore di  " + error);
        onSuccess("");
      }
    );
  }

  getAllMarkerByMatricola( matricola, dataInizio, dataFine ,onSuccess) {
    var objUser = JSON.parse(sessionStorage.getItem("user"));
    var decoded = jwt_decode(objUser.token);
    let host = process.env.REACT_APP_API_URL;
    const configHeaders = {
      headers: {
        Authorization: "Bearer " + objUser.token,
        CF: decoded.CFA,
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Headers":
          "Origin, X-Requested-With, Content-Type, Accept",
        "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
      },
    };


    // dataInizio === "" ? dataInizio = new Date().setDate(new Date().getDate() - 30) :dataInizio =  +new Date(dataInizio);
    // dataFine === "" ?dataFine = + new Date() :  dataFine = +new Date(dataFine);

    const dataOreInizio =  new Date().setDate(new Date().getDate() - 30);
    const dataOraCorrettaInizio  = new Date(dataOreInizio).setHours(0, 0, 0);

    dataInizio === ""
      ? (dataInizio = dataOraCorrettaInizio)
      : (dataInizio = +new Date(dataInizio).setHours(0, 0, 0));
    dataFine === ""
      ? (dataFine = +new Date().setHours(23,59, 59))
      : (dataFine = +new Date(dataFine).setHours(23,59, 59));

    axios.get(host + "/api/v1/mappatura/find/"+ matricola + "?dataFrom=" + dataInizio + "&dataTo="+ dataFine, configHeaders).then(
      function (result) {
        if(result.status === 401){
          logOut();
        }
        onSuccess(result);
      },
      function (error) {
        if(error.response.status === 401){
          logOut();
        }
        console.log("Errore di  " + error);
        onSuccess("");
      }
    );
  }


  getDetailMarker( idSanzione ,onSuccess) {
    var objUser = JSON.parse(sessionStorage.getItem("user"));
    var decoded = jwt_decode(objUser.token);
    let host = process.env.REACT_APP_API_URL;
    const configHeaders = {
      headers: {
        Authorization: "Bearer " + objUser.token,
        CF: decoded.CFA,
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Headers":
          "Origin, X-Requested-With, Content-Type, Accept",
        "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
      },
    };
    axios.get(host + "/api/v1/mappatura/detail/"+idSanzione, configHeaders).then(
      function (result) {
        if(result.status === 401){
          logOut();
        }
        onSuccess(result);
      },
      function (error) {
        if(error.response.status === 401){
          logOut();
        }
        console.log("Errore di  " + error);
        onSuccess("");
      }
    );
  }


  getMatricole(onSuccess){
    let host = process.env.REACT_APP_API_URL;
    var objUser = JSON.parse(sessionStorage.getItem("user"));
    var decoded = jwt_decode(objUser.token);
    const configHeaders = {
      headers: {
        Authorization: "Bearer " + objUser.token,
        CF: decoded.CFA,
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Headers":
          "Origin, X-Requested-With, Content-Type, Accept",
        "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
      },
    };
    axios.get(host + "/api/v1/user/find/", configHeaders).then(
      function (result) {
        if(result.status === 401){
          logOut();
        }
        let dataTableUtenti = [];
        // console.log(result.data)
        result.data.map((result) => {
          dataTableUtenti = [
            ...dataTableUtenti,
            {
              nome: result.nome,
              cognome: result.cognome,
              numMatricola:result.numMatricola,
              email: result.email,
              ruolo:
                result.ruoliOperatori.nomeRuolo === "0"
                  ? "Verificatore"
                  : result.ruoliOperatori.nomeRuolo === "1"
                  ? "Operatore"
                  : result.ruoliOperatori.nomeRuolo === "2"
                  ? "Operatore Avanzato"
                  : result.ruoliOperatori.nomeRuolo === "3"
                  ? "?"
                  : result.ruoliOperatori.nomeRuolo === "4" ? "Admin" : "",//result.ruoliOperatori.nomeRuolo === "4" ? "Ruolo Da Definire" : result.ruoliOperatori.nomeRuolo === "5" ? "Ruolo Da definire 2" 
              idAnagraficaOperatore: result.idAnagraficaOperatore,
            },
          ];
        });
        // console.log(dataTableUtenti);
        onSuccess(dataTableUtenti);
      },
      function (error) {
        if(error.response.status === 401){
          logOut();
        }
        console.log("errore ricerca composizione " + error);
        // onSuccess(headerDataTableSanzione, user);
      }
    )
  }

}
